module.exports = __webpack_public_path__ + "static/media/logo.94682468.png";